import { Navigate } from 'react-router-dom';
import { useRole } from '../hooks/useRole';

// Superadmin-only pages: plain admins are sent back to the overview.
const RequireSuperAdmin = ({ children }) => {
    const { isSuperAdmin } = useRole();
    return isSuperAdmin ? children : <Navigate to="/overview" replace />;
};

export default RequireSuperAdmin;
